import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  AfterViewInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { PencilButtonComponent } from '../../pencil-button/pencil-button.component';

export enum PencilModalSizeEnum {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
  FULL_WIDTH = 'full-width',
}

export const PencilModalSizeMapping: Record<PencilModalSizeEnum, string> = {
  [PencilModalSizeEnum.SMALL]: '320px',
  [PencilModalSizeEnum.MEDIUM]: '450px',
  [PencilModalSizeEnum.LARGE]: '700px',
  [PencilModalSizeEnum.FULL_WIDTH]: '100%',
};

@Component({
  selector: 'app-modal-template',
  standalone: true,
  imports: [CommonModule, PencilButtonComponent],
  templateUrl: './modal-template.component.html',
  styleUrls: ['./modal-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalTemplateComponent implements AfterViewInit {
  @Input() title?: string;
  @Input() description?: string;
  @Input() hasCloseButton = false;
  @Input() hasActions = true;
  @Input() showActionsDivider = false;
  @Input() size?: PencilModalSizeEnum;
  @Output() closeButtonClicked = new EventEmitter<Event>();

  constructor(private dialogRef: MatDialogRef<ModalTemplateComponent>) {}

  ngAfterViewInit(): void {
    if (this.dialogRef._containerInstance) {
      const ref = (this.dialogRef._containerInstance as any)._elementRef.nativeElement;
      if (ref) {
        ref.classList.add('pencil-dialog-default');
      }
    }
  }

  @HostBinding('style.max-width') get maxWidth() {
    return PencilModalSizeMapping[this.size ?? PencilModalSizeEnum.SMALL];
  }

  handleClose(event: Event): void {
    this.closeButtonClicked.emit(event);
  }
}
